import React from 'react';
import { makeStyles } from '@material-ui/core';
import ShiftContent from './ShiftContent';


export default function ShiftPerformanceContent(props) {
    const classes = useStyles();

    return (
        <React.Fragment>
            <div className={classes.title}>
                Shift Performance
            </div>
            <div className={classes.shiftContainer}>
                {props.workstation.shiftPerformances.map(x => <ShiftContent key={x.shift} performance={x.performance} shift={x.shift}></ShiftContent>)}
            </div>

        </React.Fragment>
    )

}

const useStyles = makeStyles(() => ({
title:{
    fontSize: "15px",
    fontFamily: "Lato, sans-serif",
    fontWeight: 'medium',
    color: '#8D8D8D',
    marginBottom:"10px"
},
shiftContainer:{
    display:"flex",
    flexDirection: "column",
}
}));